var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIconRequestFormData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "App_Left_side_panel_logos_20px_Test_Data",
    "data-name": "App Left side panel logos_20px_Test Data",
    d: "M6,14h8v2H6Zm0-4h8v2H6ZM12,0H4A2,2,0,0,0,2,2V18a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V6Zm4,18H4V2h7V7h5Z",
    transform: "translate(-2)",
    fill: "#3c3838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconRequestFormData);
export default __webpack_public_path__ + "static/media/FileIconRequestFormData.d8eee8d53bdbf2f989f259d5d7ea5d3d.svg";
export { ForwardRef as ReactComponent };